import React, { Component } from "react"
import * as htmlHelper from "../../helpers/html"

class HeroOverlap extends Component {
  render() {
    const { heroOverlap } = this.props
    return (
      <section className={`deck deck--top ${heroOverlap.bottomPadding || ""} ${heroOverlap.sectionBackgroundColor || ""}`}>
        <div className="hero hero__overlap style_v2">
          <span className="hero__image" style={{ backgroundImage: `url(${heroOverlap.backgroundImageUrl})` }}>
            <img src={heroOverlap.backgroundImageUrl} alt="" />
          </span>
          <div className="rich-text hero__text__overlap">
            {heroOverlap.imageHeading && htmlHelper.htmlStringToReactElement(heroOverlap.imageHeading)}
          </div>

          {!heroOverlap.label && !heroOverlap.heading && !heroOverlap.body ? null : (
            <div className={`hero__content hero__content__overlap ${heroOverlap.backgroundColor}`}>
              <h6>{heroOverlap.label && htmlHelper.htmlStringToReactElement(heroOverlap.label)}</h6>
              <div>{heroOverlap.heading && htmlHelper.htmlStringToReactElement(heroOverlap.heading)}</div>
              <div className="rich-text">{heroOverlap.body && htmlHelper.htmlStringToReactElement(heroOverlap.body)}</div>
            </div>
          )}
        </div>
      </section>
    )
  }
}
export default HeroOverlap
